import { useCallback, useMemo } from 'react';
import useAppSelector from '../app/redux/useAppSelector';
import type { EntitySelectNewOptionValues } from '../search/entitySearch/CategorizedEntitySelect';
import useAllUsers from '../user/useAllUsers';
import searchHighlight from '../utils/search/searchHighlight';
import getSuggestedEmail from './getSuggestedEmail';

const useInvitationEmailOption = () => {
  const organizationEmail = useAppSelector(
    (state) => state.session.organization.email,
  );
  const allUsers = useAllUsers();
  const existingEmails = useMemo(
    () => new Set(allUsers.map((user) => user.email)),
    [allUsers],
  );

  return useCallback(
    ({
      inputValue,
      onSelect,
    }: {
      inputValue: string;
      onSelect: (suggestedEmail: string) => void;
    }): { label: string; options: EntitySelectNewOptionValues[] } | null => {
      const suggestedEmail = getSuggestedEmail(inputValue, organizationEmail);
      if (
        (inputValue && !suggestedEmail) ||
        existingEmails.has(suggestedEmail)
      ) {
        return null;
      }
      return {
        label: 'Email invite',
        options: [
          {
            label: inputValue
              ? searchHighlight(suggestedEmail, inputValue)
              : `teammate@${organizationEmail}`,
            name: inputValue,
            value: inputValue,
            secondary: 'Invite new member with email',
            onSelect: () => onSelect(suggestedEmail),
          },
        ],
      };
    },
    [existingEmails, organizationEmail],
  );
};

export default useInvitationEmailOption;
